import { VFC } from 'react'
import { RequestBoxCompany } from 'src/models/RequestBox'
import styled from 'styled-components'
import { MESSAGE_DATE_FORMAT } from '../Message/common'
import {
  ContentContainer,
  MessageBottom,
  MessageDiv,
  Timestamp,
} from '../Message/styles'
import { RequestBoxContent } from './RequestBoxContent'

const MyRequestBoxComponent: VFC<{
  requestBox: RequestBoxCompany
}> = ({ requestBox }) => {
  return (
    <MyRequestBoxDiv>
      <ContentContainer>
        <RequestBoxContent requestBox={requestBox} />
      </ContentContainer>
      {requestBox.requestAt && (
        <MessageBottom>
          <Timestamp>
            {requestBox.requestAt.format(MESSAGE_DATE_FORMAT)}
          </Timestamp>
        </MessageBottom>
      )}
    </MyRequestBoxDiv>
  )
}

export const MyRequestBox = styled(MyRequestBoxComponent)``

const MyRequestBoxDiv = styled(MessageDiv)`
  justify-content: flex-end;
  ${ContentContainer} {
    min-width: unset;
  }
  ${MessageBottom} {
    left: unset;
    right: 0;
  }
`
